import { render, staticRenderFns } from "./SideBarCutSew.vue?vue&type=template&id=685893ad"
import script from "./SideBarCutSew.vue?vue&type=script&lang=js"
export * from "./SideBarCutSew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports